export function setCounts (state, counts) {
  state.counts = counts
}
